
import React from "react";
import styles from "../styles/map.module.css";

export default function Map() {
  return (
    <div className={styles.mapContainer}>
      <iframe
        title="Bournemouth Scout Group Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2523.292064195676!2d-1.917295324216863!3d50.76822287165461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4873a3b5854e1b95%3A0x9e8bd43b8c7851c0!2s21st%20Bournemouth%20Scout%20Group!5e0!3m2!1sen!2suk!4v1755599548553!5m2!1sen!2suk"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
